export const LENS_TRANSITION_DURATION_MS = 1450
export const LENS_RELEASE_PHASE_SHARE = 0.42

function clamp(value: number, min: number, max: number) {
  return Math.min(max, Math.max(min, value))
}

export function easeInOutSine(value: number) {
  return -(Math.cos(Math.PI * value) - 1) / 2
}

export function easeOutCubic(value: number) {
  return 1 - (1 - value) ** 3
}

export function blendColorChannel(from: number, to: number, mix: number) {
  return Math.round(from + (to - from) * clamp(mix, 0, 1))
}
